import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-red-600 border border-red-600 my-[10px] text-white text-center fixed md:top-[80px] top-[60px] shadow-lg left-[50%] translate-x-[-50%] font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[650px] w-[90%] p-[20px]"
}
const _hoisted_2 = { class: "text-gray-600 flex relative text-sm bg-white border border-gray-400 p-[10px] w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", { class: "items-center p-[5px] flex w-[25px]" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "checkbox",
    name: "article-checkbox-{{ article.id }}",
    id: "article-checkbox-{{ article.id }}"
  })
], -1)
const _hoisted_4 = { class: "items-center p-[5px] flex w-[25px]" }
const _hoisted_5 = { class: "items-center md:w-[calc(100%/6)] w-[calc(100%/3)] p-[5px] flex" }
const _hoisted_6 = { class: "items-center md:w-[calc(100%/6)] w-[calc(100%/3)] p-[5px] flex overflow-x-auto flex-wrap" }
const _hoisted_7 = { class: "items-center md:w-[calc(100%/6)] w-[calc(100%/3)] p-[5px] hidden text-justify" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "items-center md:w-[calc(100%/6)] w-[calc(100%/3)] p-[5px] flex" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "items-center md:w-[calc(100%/6)] w-[calc(100%/3)] overflow-x-auto p-[5px] md:flex hidden" }
const _hoisted_12 = { class: "items-center md:w-[calc(100%/6)] w-[calc(100%/3)] p-[5px] overflow-x-auto md:flex hidden" }
const _hoisted_13 = { class: "items-center md:w-[calc(100%/6)] w-[calc(100%/3)] p-[5px] md:flex justify-center flex-wrap hidden" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "fixed top-0 left-0 w-full h-full flex justify-center items-center bg-gray-800 bg-opacity-50"
}
const _hoisted_18 = { class: "bg-white p-8 rounded-lg" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold mb-4" }, "Confirmez la suppression de l'article", -1)

import Article from '@/components/types/Article'
    import axios from 'axios';
    import { useRouter } from 'vue-router';
    import axiosInstance from '@/plugins/axios';
    
    import { ref } from 'vue';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'rowArticle',
  props: {
    articles: {}
  },
  setup(__props: any) {

    const router = useRouter();
    const errorMessage = ref("");
    
    const props = __props;

    const publishArticle = async (newArticleId: number) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;

      const publishResponse = await axiosInstance.put(`/articles/${newArticleId}/publish/`, null, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (publishResponse.status === 200 || publishResponse.status === 201 || publishResponse.status === 204 ) {
        window.location.reload();
      } else {
        console.error('Erreur lors de la publication de l\'article');
      }
    } catch (error) {
      console.error('Erreur lors de la publication de l\'article:', error);
    }
  };

  const showConfirmationModal = ref(false);
const selectedArticle = ref<Article | null>(null);

const confirmDelete = (article: Article) => {
  selectedArticle.value = article;
  showConfirmationModal.value = true;
};

const deleteArticle = async () => {
  if (!selectedArticle.value) return;

  try {
    const token = localStorage.getItem('token');
    if (!token) return;

    const response = await axiosInstance.delete(`/articles/${selectedArticle.value.id}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200 || response.status === 204) {
      window.location.reload();
    }
  } catch (error) {
    errorMessage.value = 'Erreur lors de la suppression de l\'article: Vous n\'avez pas les autorisations requises';
    hideErrorMessageAfterDelay();
  } finally {
    selectedArticle.value = null;
    showConfirmationModal.value = false;
  }
};

const confirmUpdate = (article: Article) => {
  selectedArticle.value = article;
  router.push({ name: 'AddAnArticleWith', params: { id: article.id } });
};


const cancelDelete = () => {
  selectedArticle.value = null;
  showConfirmationModal.value = false;
};

const hideErrorMessageAfterDelay = () => {
  setTimeout(() => {
    errorMessage.value = ''; 
  }, 5000);
};
    



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.articles, (article) => {
      return (_openBlock(), _createElementBlock("tr", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("td", _hoisted_4, _toDisplayString(article.id), 1),
        _createElementVNode("td", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: { name: 'article', params: { id: article.id }},
            class: "hover:text-black hover:underline duration-300"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(article.title), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _createElementVNode("td", _hoisted_6, _toDisplayString(article.author_username), 1),
        _createElementVNode("td", _hoisted_7, [
          _createElementVNode("div", {
            innerHTML: article.content
          }, null, 8, _hoisted_8)
        ]),
        _createElementVNode("td", _hoisted_9, [
          _createElementVNode("img", {
            src: article.image,
            class: "w-full",
            alt: ""
          }, null, 8, _hoisted_10)
        ]),
        _createElementVNode("td", _hoisted_11, _toDisplayString(article.date), 1),
        _createElementVNode("td", _hoisted_12, _toDisplayString(article.source), 1),
        _createElementVNode("td", _hoisted_13, [
          _createElementVNode("i", {
            class: "fa-solid fa-trash-can bg-red-500 text-white p-[10px] rounded-[5px] mr-[5px] text-xl cursor-pointer",
            onClick: ($event: any) => (confirmDelete(article))
          }, null, 8, _hoisted_14),
          _createElementVNode("i", {
            class: "fa-solid fa-file-pen bg-blue-500 text-white p-[10px] rounded-[5px] ml-[5px] text-xl cursor-pointer",
            onClick: ($event: any) => (confirmUpdate(article))
          }, null, 8, _hoisted_15),
          (!article.is_published)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "bg-green-600 p-[10px] rounded-[5px] m-[10px] text-white font-bold text-sm",
                onClick: ($event: any) => (publishArticle(article.id))
              }, "Published", 8, _hoisted_16))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 256)),
    (showConfirmationModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("p", null, "ID : " + _toDisplayString(selectedArticle.value.id), 1),
            _createElementVNode("p", null, "Titre : " + _toDisplayString(selectedArticle.value.title), 1),
            _createElementVNode("div", { class: "flex justify-end mt-6" }, [
              _createElementVNode("button", {
                class: "px-4 py-2 bg-red-500 text-white rounded mr-4",
                onClick: deleteArticle
              }, "Supprimer"),
              _createElementVNode("button", {
                class: "px-4 py-2 bg-gray-300 rounded",
                onClick: cancelDelete
              }, "Annuler")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})